import { Helmet } from "react-helmet-async";

import seoData from "../../config/seoData";

export default function SEO({ page }) {
  const business = seoData.business;

  const seo = seoData.pages[page];

  if (!seo) return null;

  const fullUrl = business.url + seo.path;

  const localBusinessSchema = {
    "@context": "https://schema.org",

    "@type": "DryCleaningOrLaundry",

    name: business.name,
    geo: {
      "@type": "GeoCoordinates",
      latitude: 43.850855,
      longitude: -79.020374,
    },

    keywords: [
      "Dry Cleaning Ajax",
      "Laundry Service Ajax",
      "Wedding Dress Cleaning Ajax",
      "Alterations Ajax",
      "Rug Cleaning Ajax",
      "Shoe Repair Ajax",
      "Handbag Cleaning Ajax",
    ],

    description:
      "Comet Cleaners provides dry cleaning, laundry service, alterations, wedding dress cleaning, rug cleaning, shoe repair, handbag cleaning and pickup & delivery throughout Ajax, Pickering and Whitby.",
    image: business.image,

    url: business.url,

    email: business.email,

    address: {
      "@type": "PostalAddress",

      streetAddress: business.address.street,

      addressLocality: business.address.city,

      addressRegion: business.address.province,

      postalCode: business.address.postalCode,

      addressCountry: business.address.country,
    },

    areaServed: business.serviceAreas,

    makesOffer: business.services.map((service) => ({
      "@type": "Offer",

      itemOffered: {
        "@type": "Service",

        name: service,
      },
    })),
  };

  const faqSchema = {
    "@context": "https://schema.org",

    "@type": "FAQPage",

    mainEntity: [
      {
        "@type": "Question",

        name: "Do you offer pickup and delivery?",

        acceptedAnswer: {
          "@type": "Answer",

          text: "Yes. We offer pickup and delivery services across Ajax, Pickering and Whitby.",
        },
      },

      {
        "@type": "Question",

        name: "Do you clean wedding dresses?",

        acceptedAnswer: {
          "@type": "Answer",

          text: "Yes. We provide professional wedding dress cleaning and preservation services.",
        },
      },

      {
        "@type": "Question",

        name: "Do you offer alterations?",

        acceptedAnswer: {
          "@type": "Answer",

          text: "Yes. We provide hemming and garment alteration services.",
        },
      },

      {
        "@type": "Question",

        name: "Do you clean rugs and curtains?",

        acceptedAnswer: {
          "@type": "Answer",

          text: "Yes. We provide rug, curtain, comforter and household textile cleaning.",
        },
      },
    ],
  };

  return (
    <Helmet>
      <title>{seo.title}</title>

      <meta name="description" content={seo.description} />

      <meta name="keywords" content={seo.keywords} />

      <meta name="robots" content="index,follow" />

      <link rel="canonical" href={fullUrl} />

      {/* Open Graph */}

      <meta property="og:type" content="website" />

      <meta property="og:title" content={seo.title} />

      <meta property="og:description" content={seo.description} />

      <meta property="og:image" content={business.image} />

      <meta property="og:url" content={fullUrl} />

      <meta property="og:site_name" content={business.name} />

      <meta property="og:locale" content="en_CA" />

      {/* Twitter */}

      <meta name="twitter:card" content="summary_large_image" />

      <meta name="twitter:title" content={seo.title} />

      <meta name="twitter:description" content={seo.description} />

      <meta name="twitter:image" content={business.image} />

      {/* AI + Google Schema */}

      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>

      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",

          name: "Comet Cleaners",

          url: "https://cometcleaners.ca",

          potentialAction: {
            "@type": "SearchAction",

            target: "https://cometcleaners.ca/services?q={search_term_string}",

            "query-input": "required name=search_term_string",
          },
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",

          "@type": "Organization",

          name: "Comet Cleaners",

          url: "https://cometcleaners.ca",

          logo: "https://cometcleaners.ca/logo-bc.png",

          email: "cometcleaners5@gmail.com",
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Comet Cleaners",
          url: "https://cometcleaners.ca",
          logo: "https://cometcleaners.ca/logo-bc.png",
          email: "cometcleaners5@gmail.com",
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "Comet Cleaners",
          url: "https://cometcleaners.ca",
        })}
      </script>
    </Helmet>
  );
}
